import React from 'react';

import { NextPage } from 'next';

import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner';

export const LoadingPage: NextPage = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingSpinner />
    </div>
  );
};
